// Imports: local files.
import {
  GET_SPONSORS_START,
  GET_SPONSORS_SUCCESS,
  GET_SPONSORS_FAILED,
  GET_SPONSORS_RESET,
  GET_SPONSOR_START,
  GET_SPONSOR_SUCCESS,
  GET_SPONSOR_FAILED,
  GET_SPONSOR_RESET,
  CREATE_SPONSOR_START,
  CREATE_SPONSOR_SUCCESS,
  CREATE_SPONSOR_FAILED,
  CREATE_SPONSOR_RESET,
  UPDATE_SPONSOR_START,
  UPDATE_SPONSOR_SUCCESS,
  UPDATE_SPONSOR_FAILED,
  UPDATE_SPONSOR_RESET,
  DELETE_SPONSOR_START,
  DELETE_SPONSOR_SUCCESS,
  DELETE_SPONSOR_FAILED,
  DELETE_SPONSOR_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const sponsorsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All SPONSORS
     * =======================================================================
     */
    case GET_SPONSORS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_SPONSORS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_SPONSORS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_SPONSORS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One SPONSOR
     * =======================================================================
     */
    case GET_SPONSOR_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_SPONSOR_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_SPONSOR_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_SPONSOR_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create SPONSOR
     * =======================================================================
     */
    case CREATE_SPONSOR_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_SPONSOR_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_SPONSOR_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_SPONSOR_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One SPONSOR
     * =======================================================================
     */
    case UPDATE_SPONSOR_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_SPONSOR_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_SPONSOR_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_SPONSOR_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One SPONSOR
     * =======================================================================
     */
    case DELETE_SPONSOR_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_SPONSOR_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_SPONSOR_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_SPONSOR_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default sponsorsReducer;
